import React,{useEffect,useRef, useState} from 'react';
import { Link } from 'react-router-dom';
import Tabmenu from './tabmenu/Tabmenu';
import Menu from '../icons/Menu';
export default function AskAdvice() {
    let h = window.innerHeight-63;

    const [dataset,setDataset] = useState([]);

    useEffect(()=>{
      setDataset(JSON.parse(sessionStorage.getItem('patientdata')));
    }, []);
  return (
    <>
      <div className=" bg-gray-50 relative" style={{height:h+'px'}}>
        <div className='blur-sm'>
            <div className='flex text-black p-4 pt-6 h-24  bg-gray-100 max-w  z-50 w-full'>
                <div>
                    {dataset?.imgUrl? <img src={dataset?.imgUrl} className=" mx-2 rounded-full object-cover h-12 w-12"/> :<div className=" mx-2 rounded-full object-cover bg-gray-400 h-12 w-12"/>
        }
                    
                    </div>
                <div className='mt-1 flex-1'>
                    <h4 className='font-bold'>{dataset?.patientName}</h4>
                    <h6 className='text-xs'>{dataset?.description}</h6>
                </div>
            </div>
            <div className=' text-primary-800 p-4 relative overflow-hidden  rounded-b-3xl bg-slate-50'>
            <div className=''>
                <img src="../../../images/slide1.png" className=" absolute bottom-0 right-0"/>
                <div className='relative z-20 pb-28'>
                <div className='text-3xl pt-5 font-semibold'>How are you <br />feeling today?</div>
                <button className='bg-primary flex py-2 pl-2 pr-4 rounded-full text-white mt-4'>
                    <img src="../../../images/condetionbtn.svg" className=" mx-2 mt-1 rounded-full"/> Add condition
                </button>
                </div>
            </div>
            </div>
        </div>
        <div className='absolute w-full h-full bottom-0 z-40 flex flex-col justify-between'>
            <div className='h-1/6'></div>
            <div className='relative' style={{backgroundImage:'Loading_prog.gif'}}>
                <Link to="/Dashboard"  className='h-8 w-8 rounded-full text-blue-500 bg-white  top-3  px-1 pt-1 text-2xl absolute right-4'>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </Link>
                <iframe src="https://chatbot.myprognosis.ai/" title="PROGNOSIS AI" className='w-full ' style={{height:'526px'}}></iframe>
            </div>

        </div>

      </div>       
          
         
      <Tabmenu />
    </>
  );
}